import React, { useState, useEffect } from "react"
import StepsRegister from "../organisms/steps-register/steps-register"
import Step1Register from "../molecules/step1-register/step1-register"
import Step2Register from "../molecules/step2-register/step2-register"
import Step3Register from "../molecules/step3-register/step3-register"
import { useForm } from "react-hook-form"
import Layout from "../../shared/components/organisms/layout/layout"
import { useStaticQuery, graphql, withPrefix } from "gatsby"
import { pushDataLayerEvent } from "../../shared/utils/metricManagementUtil"
import Step4Register from "../molecules/step4-register/step4-register"
import RegisterService from "../../shared/services/register-service"
import Step5Register from "../molecules/step5-register/step5-register"
import Step6Register from "../molecules/step6-register/step6-register"
import StepVerificationMail from "./../../shared/components/modals/step-verification-mail/step-verification-mail"
import StepCodeVerification from "./../../shared/components/modals/step-code-verification/step-code-verification"
import PreparentalAuthorization from "../molecules/pre-parental-authorization/pre-parental-authorization"
import SEO from "../../shared/seo"
import StandardModal from "../../shared/components/modals/standard-modal/standard-modal"
import ModalUserExists from "../molecules/modal-user-exists/modal-user-exists"
import {
  censorCellPhone,
  censorMail,
} from '../../shared/utils/formatString'

const RegisterTemplate = props => {
  const resultQuery = useStaticQuery(
    graphql`
      query TERMS_QUERY {
        allContentfulNolFooter {
          nodes {
            node_locale
            politicaPrivacidadDatos
            terminosYCondiciones
            redireccionPoliticaPrivacidadDatos
            redireccionTerminosYCondiciones
          }
        }

        allContentfulNolPaises {
          nodes {
            mayorEdad
            node_locale
            codigoIcu
          }
        }
      }
    `
  )

  var termsContentful = resultQuery.allContentfulNolFooter.nodes.filter(
    e => e.node_locale === process.env.LOCALE
  )[0]

  var adressContentful = resultQuery.allContentfulNolPaises.nodes.filter(
    e => e.codigoIcu === process.env.LOCALE
  )[0]

  // var mobile = typeof window !== "undefined" ?  window.innerWidth < 1024 ? true : false : false
  // validate mobile app
  const [isMobile, setMobileBool] = React.useState(false)

  // wait for respose server
  const [loadServer, setLoadServer] = React.useState(false)

  // send active modal to layout
  const [modalActive, setModalActive] = React.useState()

  const [loadingButton, setloadingButton] = useState(false)

  var userData
  if (typeof window !== "undefined") {
    userData = JSON.parse(sessionStorage.getItem("userData"))
  }
  const [existEmai, setExistEmai] = React.useState(false)
  const [existCellphone, setExistCellphone] = React.useState(false)
  const [existDataParent, setExistDataParent] = React.useState(false)
  const [adult, setAdult] = React.useState(userData ? userData.adult : true)
  const [fulldate, setFulldate] = React.useState(
    userData ? userData.fullDate : ""
  )
  const [values, setValues] = React.useState({
    name: userData ? userData.name : "",
    lastName: userData ? userData.lastName : "",
    email: userData ? userData.email : "",
    date: userData ? userData.date : "",
    month: userData ? userData.month : "",
    year: userData ? userData.year : "",
    fullDate: userData ? userData.fullDate : "",
    cellPhone: userData ? userData.cellPhone : "",
    codeDestination: userData ? userData.codeDestination : "EMAIL",
    password: userData ? userData.password : "",
    country: process.env.COUNTRY_CODE,
    countryState: userData ? userData.countryState : "",
    city: userData ? userData.city : "",
    address: userData ? userData.address : "",
    zipcode: "",
    addressAdditional: userData ? userData.addressAdditional : "",
    parentName: userData ? userData.parentName : null,
    parentCodeDestination: userData ? userData.parentCodeDestination : "EMAIL",
    parentEmail: userData ? userData.parentEmail : null,
    parentCellPhone: userData ? userData.parentCellPhone : null,
    neighbor: userData ? userData.neighbor : null,
    nickName: userData ? userData.nickName : null,
  })

  const {
    register,
    unregister,
    getValues,
    setError,
    clearErrors,
    setValue,
    handleSubmit,
    errors,
    trigger,
  } = useForm({
    defaultValues: {
      date: userData ? userData.date : "",
      month: userData ? userData.month : "",
      year: userData ? userData.year : "",
      name: userData ? userData.name : "",
      lastName: userData ? userData.lastName : "",
      email: userData ? userData.email : "",
      cellPhone: userData ? userData.cellPhone : "",
      codeDestination: userData ? userData.codeDestination : "EMAIL",
      password: userData ? userData.password : "",
      country: process.env.COUNTRY_CODE,
      countryState: userData ? userData.countryState : "",
      city: userData ? userData.city : "",
      address: userData ? userData.address : "",
      zipcode: "",
      addressAdditional: userData ? userData.addressAdditional : "",
      parentName: userData ? userData.parentName : null,
      parentCodeDestination: userData
        ? userData.parentCodeDestination
        : "EMAIL",
      parentEmail: userData ? userData.parentEmail : null,
      parentCellPhone: userData ? userData.parentCellPhone : null,
      nickName: userData ? userData.nickName : null,
    },
  })
  const handleChange = e => {
    setExistEmai(false)
    setExistCellphone(false)
    setExistDataParent(false)
    trigger({ name: e.target.name })
    const data = getValues()
    if (data.date && data.month && data.year) {
      const dd = data.date < 10 ? "0" + data.date : data.date
      const mm = data.month < 10 ? "0" + data.month : data.month
      const newDate = dd + "/" + mm + "/" + data.year
      setFulldate(newDate)
      if (calcularEdad(data) < adressContentful.mayorEdad) {
        setAdult(false)
      } else {
        setAdult(true)
      }
    }
    setValues({ ...values, [e.target.name]: e.target.value })
    saveSesionStorage()
  }
  function calcularEdad(fecha) {
    var hoy = new Date()
    var edad = hoy.getFullYear() - fecha.year
    var m = hoy.getMonth() - fecha.month

    if (m < 0 || (m === 0 && hoy.getDate() < fecha.date)) {
      edad--
    }

    return edad
  }
  const [inscriptionPlace, setInscriptionPlace] = useState({
    inscriptionMode: null,
    competitionId: null,
    urlActivity: null,
  })
  useEffect(() => {
    const Url = localStorage.getItem("PREV_PARAMS")
    // creamos la instancia
    const urlParams = new URLSearchParams(Url)
    if (urlParams.get("id")) {
      setInscriptionPlace({
        urlActivity: urlParams.get("url"),
        competitionId: urlParams.get("id"),
        inscriptionMode: "concursos-portal-web",
      })
    } else if (urlParams.get("inscriptionMedium")) {
      setInscriptionPlace({
        urlActivity: urlParams.get("url"),
        competitionId: null,
        inscriptionMode: urlParams.get("inscriptionMedium"),
      })
    } else {
      setInscriptionPlace({
        urlActivity: urlParams.get("url"),
        competitionId: null,
        inscriptionMode: "portal-web",
      })
    }
  }, [])

  const saveSesionStorage = () => {
    const newData = {
      adult: adult,
      date: values.date,
      month: values.month,
      year: values.year,
      fullDate: fulldate,
      name: values.name,
      lastName: values.lastName,
      email: values.email,
      cellPhone: values.cellPhone,
      codeDestination: values.codeDestination,
      tycAcepted: 1,
      uytdAcepted: 1,
      pointsAcepted: 1,
      password: values.password,
      country: values.country,
      countryState: values.countryState,
      city: values.city,
      address: values.address,
      parentName: values.parentName,
      parentCodeDestination: values.parentCodeDestination,
      parentEmail:
        typeof values.parentEmail === "string"
          ? values.parentEmail.toLowerCase()
          : values.parentEmail,
      parentCellPhone: values.parentCellPhone,
      addressAdditional: values.addressAdditional,
      nickName: values.nickName,
    }
    if (typeof window !== "undefined") {
      sessionStorage.setItem("userData", JSON.stringify(newData))
    }
  }

  const onSubmit = type => {
    setLoadServer(true)
    saveSesionStorage()
    const dataService = {
      adult: adult,
      competitionId: inscriptionPlace.competitionId,
      inscriptionMode: inscriptionPlace.inscriptionMode,
      birthdate: fulldate,
      name: values.name,
      lastName: values.lastName,
      email: values.email.replaceAll(" ", ""),
      cellPhone:
        values.cellPhone === null ||
        values.cellPhone === "" ||
        values.cellPhone === " " ||
        values.cellPhone === undefined
          ? null
          : process.env.COUNTRY_PHONE_PREFIX + parseInt(values.cellPhone, 10),
      codeDestination: values.codeDestination,
      tycAcepted: 1,
      uytdAcepted: 1,
      pointsAcepted: 1,
      password: values.password,
      country: values.country,
      location:
        type === "preRegister"
          ? null
          : {
              city: values.city,
              address:
                (process.env.LOCALE === "es-PR" || process.env.LOCALE === "es-AR") && values.zipcode
                  ? `${values.zipcode.toLocaleUpperCase()}, ${values.address}`
                  : values.address,
              addressDetail:
                values.neighbor && values.addressAdditional
                  ? values.neighbor + " | " + values.addressAdditional
                  : values.neighbor
                  ? values.neighbor
                  : values.addressAdditional,
            },
      parent:
        type === "preRegister"
          ? null
          : values.parentName === null
          ? null
          : values.parentCodeDestination === "SMS"
          ? {
              cellPhone:
                values.parentCellPhone === null || values.parentCellPhone === ""
                  ? null
                  : process.env.COUNTRY_PHONE_PREFIX +
                    parseInt(values.parentCellPhone, 10),
              name: values.parentName,
              verificationMode:
                values.parentName === null
                  ? null
                  : values.parentCodeDestination,
            }
          : {
              email: values.parentEmail.toLowerCase().replaceAll(" ", ""),
              name: values.parentName,
              verificationMode:
                values.parentName === null
                  ? null
                  : values.parentCodeDestination,
            },
    }
    const nickName = getValues("nickName")
    if (props.pageContext.slug === "nombre" && nickName) {
      validateNickName(nickName)
    } else if (type === "preRegister") {
      setloadingButton(true)
      RegisterService.preRegister(dataService)
        .then(response => {
          setLoadServer(false)
          if (response.status === 200) {
            pushDataLayerEvent({
              event: "sign_up",
              method: "form"
            })
            var dataCopy = JSON.parse(sessionStorage.getItem("userData"))
            dataCopy.password = ""
            sessionStorage.setItem("userData", JSON.stringify(dataCopy))
            if (response.data.state === "ACTIVO") {
              setExistEmai(true)
              setloadingButton(false)
              setModalActive(
                <ModalUserExists 
                  setModalActive={setModalActive} 
                  title={`Hola ${response.data.name}`} 
                  subDescription={'¡Estamos aquí para ayudarte en lo que necesites!'}
                  description={
                    <>
                   Tu cuenta ya está activa en nuestro Mundo Nosotras.
                   Utilizaste el correo electrónico <b>{censorMail(response.data.email)}</b> y el número de celular {' '}
                    <b>{censorCellPhone(response.data.cellPhone)}</b>.
                     Si deseas, puedes actualizar tus datos, iniciar sesión o validar tu información nuevamente.{' '} <br/>
                    
                </>}
                />
              )

            } else if (
              response.data.state === "REGISTRADO" ||
              response.data.state === "PENDIENTE"
            ) {
              setloadingButton(false)
              if (response.data.adult) {
                RegisterService.codeVerificationResend({
                  username: response.data.email,
                }).then(res => {
                  if (response.data.codeDestination === "EMAIL") {
                    setModalActive(<StepVerificationMail userEmail={response.data.email} />)
                  } else {
                    setModalActive(
                      <StepCodeVerification
                        setSuccessRegisterModal={setModalActive}
                      />
                    )
                  }
                })
              } else {
                var payload = "?username=" + userData.email
                RegisterService.parentResentConfirmation(payload).then(res => {
                  if (res.status === 200) {
                    setModalActive(<PreparentalAuthorization />)
                  }
                })
              }
            } else {
              window.location.href = withPrefix(
                "/" + props.pageContext.next.slug
              )
            }
          } else if (
            response.status === 400 &&
            response.errorCode === "DEM010"
          ) {
            setError("email", {
              type: "DEM010",
              message: response.userMessage,
            })
            setloadingButton(false)
          } else {
            if (response.status === 400 && response.errorCode === "DEM016") {
              setExistCellphone(true)
              setModalActive(
                <ModalUserExists 
                  setModalActive={setModalActive} 
                  title={`Hola ${response.data.name}`} 
                  subDescription={'¡Estamos aquí para ayudarte en lo que necesites!'}
                  description={
                    <>
                   Tu cuenta ya está activa en nuestro Mundo Nosotras.
                   Utilizaste el correo electrónico <b>{censorMail(response.data.email)}</b> y el número de celular {' '}
                    <b>{censorCellPhone(response.data.cellPhone)}</b>.
                     Si deseas, puedes actualizar tus datos, iniciar sesión o validar tu información nuevamente.{' '} <br/>
                </>}
                />
              )
            } else {
              console.log("error ", response.developerMessage)
            }
            setloadingButton(false)
          }
        })
        .catch(error => {
          console.error(error)
        })
    } else if (type === "register") {
      setloadingButton(true)
      if (
        values.email === values.parentEmail ||
        values.cellPhone === values.parentCellPhone
      ) {
        setExistDataParent(true)
        setLoadServer(false)
      } else {
        // DataLayer
        try {
          console.log("send datalayer")
          window.dataLayer.push({
            event: "salesForcePush",
            convid: "null",
            displayorder: "null",
            linkalias: "Registro confirmacion",
            amt: "null",
            unit: "null",
          })
        } catch (e) {
          console.log("Error", e)
        }

        const isFromVConfident = localStorage.getItem("isFromVConfident")
        RegisterService.register({
          ...dataService,
          nickname: values.nickName,
          isFromVConfident: !!isFromVConfident,
        })
          .then(response => {
            setLoadServer(false)
            if (response.status === 200) {
              pushDataLayerEvent({
                event: "sign_up",
                method: "form"
              })
              var dataCopy = JSON.parse(sessionStorage.getItem("userData"))
              dataCopy.password = null
              sessionStorage.setItem("userData", JSON.stringify(dataCopy))
              if (adult) {
                if (userData.codeDestination === "EMAIL") {
                    setModalActive(
                    <StepVerificationMail
                      urlActivity={inscriptionPlace.urlActivity}
                      userEmail={userData.email}
                    />
                  )
                } else {
                  setModalActive(
                    <StepCodeVerification
                      urlActivity={inscriptionPlace.urlActivity}
                      setSuccessRegisterModal={setModalActive}
                    />
                  )
                }
              } else {
                setModalActive(
                  <PreparentalAuthorization
                    urlActivity={inscriptionPlace.urlActivity}
                  />
                )
              }
            } else if (
              response.status === 400 &&
              response.errorCode === "DEM010"
            ) {
              setError("parentEmail", {
                type: "DEM010",
                message: response.userMessage,
              })
            } else {
              setModalActive(
                <StandardModal
                  title="Ups!"
                  subtitle="ALGO HA FALLADO"
                  description={
                    <>No eres tú, somos nosotros. Porfa inténtalo más tarde.</>
                  }
                  button_title={"Aceptar"}
                  click={() => {
                    setModalActive(null)
                  }}
                />
              )
              console.error(response.developerMessage)
            }
          })
          .catch(error => {
            console.error(error)
          })
      }
    } else {
      window.location.href = withPrefix("/" + props.pageContext.next.slug)
    }
  }

  const validateNickName = nickName => {
    setloadingButton(true)
    RegisterService.validateNickname(
      `?nickname=${nickName}&dateBirth=${
        Number(values.date) < 10 ? "0" + values.date : values.date
      }/${values.month < 10 ? "0" + values.month : values.month}/${values.year}`
    )
      .then(response => {
        const { data: isUserAvailable, status } = response
        if (status !== 200) {
          setError("nickName", {
            type: "nickName-invalid",
            message: "Ocurrio un error",
          })
          return
        }
        if (isUserAvailable) {
          setError("nickName", {
            type: "nickName-invalid",
            message: "Usuario no existe",
          })
        } else {
          window.location.href = withPrefix("/" + props.pageContext.next.slug)
        }
      })
      .catch(error => {
        console.log(error)
        setError("nickName", {
          type: "nickName-invalid",
          message: "Ocurrio un error",
        })
      })
      .finally(() => {
        setloadingButton(false)
      })
  }
  const hadleBack = e => {
    e.stopPropagation()
    e.preventDefault()
    window.location.href = withPrefix("/" + props.pageContext.prev.slug)
  }

  const handleInitialStep = () => {
    switch (props.pageContext.slug) {
      case "fecha-de-nacimiento":
        return 1
      case "nombre":
        return 2
      case "correo":
        return 3
      case "contrasena":
        return 4
      case "direccion":
        return 5
      case "acudiente":
        return 6
      default:
        break
    }
  }

  const handleStep = () => {
    switch (props.pageContext.slug) {
      case "fecha-de-nacimiento/":
        return (
          <Step1Register
            handleChange={handleChange}
            onSubmit={onSubmit}
            handleSubmit={handleSubmit}
            register={register}
            errors={errors}
            getValues={getValues}
            setError={setError}
            clearErrors={clearErrors}
            setValue={setValue}
          />
        )
      case "nombre":
        return (
          <Step2Register
            errors={errors}
            hadleBack={hadleBack}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            loadingButton={loadingButton}
            onSubmit={onSubmit}
            register={register}
            setValue={setValue}
            setValues={setValues}
            userData={userData}
            values={values}
          />
        )
      case "correo":
        return (
          <Step3Register
            values={values}
            handleChange={handleChange}
            hadleBack={hadleBack}
            handleSubmit={handleSubmit}
            onSubmit={onSubmit}
            register={register}
            errors={errors}
            unregister={unregister}
            getValues={getValues}
            setValue={setValue}
            setValues={setValues}
            existEmai={existEmai}
            existCellphone={existCellphone}
            userData={userData}
            loadServer={loadServer}
            loadingButton={loadingButton}
            setModalActive={setModalActive}
          />
        )
      case "contrasena":
        return (
          <Step4Register
            handleChange={handleChange}
            hadleBack={hadleBack}
            handleSubmit={handleSubmit}
            onSubmit={onSubmit}
            register={register}
            errors={errors}
            userData={userData}
            setValue={setValue}
          />
        )
      case "direccion":
        return (
          <Step5Register
            handleChange={handleChange}
            hadleBack={hadleBack}
            handleSubmit={handleSubmit}
            onSubmit={onSubmit}
            register={register}
            errors={errors}
            userData={userData}
            loadServer={loadServer}
            adult={adult}
            setValues={setValues}
            values={values}
            loadingButton={loadingButton}
          />
        )
      case "acudiente":
        return (
          <Step6Register
            handleChange={handleChange}
            hadleBack={hadleBack}
            handleSubmit={handleSubmit}
            onSubmit={onSubmit}
            register={register}
            errors={errors}
            getValues={getValues}
            userData={userData}
            loadServer={loadServer}
            values={values}
            existDataParent={existDataParent}
          />
        )
      default:
        break
    }
  }

  const updateDimensions = () => {
    setMobileBool(window.innerWidth < 1024 ? true : false)
  }

  React.useEffect(() => {
    updateDimensions()
    window.addEventListener("resize", updateDimensions)
    return () => {
      window.removeEventListener("resize", updateDimensions)
    }
  }, [])

  return (
    <Layout mobile={isMobile} modalActive={modalActive} title={props.pageContext.metaTitulo}>
      <SEO
        title={props.pageContext.metaTitulo}
        description={props.pageContext.metaDescripcion.metaDescripcion}
        url={"/registro/" + props.pageContext.slug}
      />
      <StepsRegister
        step={handleInitialStep()}
        termsContentful={termsContentful}
        stepsLenght={adult ? 5 : 6}
      >
        {handleStep()}
      </StepsRegister>
    </Layout>
  )
}

export default RegisterTemplate
